const BUILD_ENV = process.env.BUILD_ENV;

const config = {
  dev: {
    ROOTPATH: 'https://srv-iorder-dev.cpcti.com', // PHP 接口域名
    IORDERPATH: 'https://gateway-iorder-dev.cpcti.com', // python 接口域名
    GATEWAYPATH: 'https://public-dev.cpcti.com/', //公共服务域名
    PAGEPATH: 'https://page-h5-dev.cpcti.com/',
    EXPERTPATH: 'https://gateway-dev.cpcti.com'
  },
  // dev: {
  //   ROOTPATH: 'https://srv-iorder.cpcti.com', // PHP 接口域名
  //   IORDERPATH: 'https://gateway-iorder.cpcti.com', // python 接口域名
  //   GATEWAYPATH: 'https://public.cpcti.com/', //公共服务域名
  //   PAGEPATH: 'https://page-h5.cpcti.com/',
  //   EXPERTPATH: 'https://gateway.cpcti.com'
  // },
  prd: {
    ROOTPATH: 'https://srv-iorder.cpcti.com', // PHP 接口域名
    IORDERPATH: 'https://gateway-iorder.cpcti.com', // python 接口域名
    GATEWAYPATH: 'https://public.cpcti.com/', //公共服务域名
    PAGEPATH: 'https://page-h5.cpcti.com/',
    EXPERTPATH: 'https://gateway.cpcti.com'
  },
};

export const ROOTPATH = config[BUILD_ENV].ROOTPATH;
export const IORDERPATH = config[BUILD_ENV].IORDERPATH;
export const GATEWAYPATH = config[BUILD_ENV].GATEWAYPATH;
export const PAGEPATH = config[BUILD_ENV].PAGEPATH;
export const EXPERTPATH = config[BUILD_ENV].EXPERTPATH;
export const defaultNavCfg = {
  navTitle: '',
  navTitleColor: '#000000',
  navBackColor: '#FFFFFF',
  leftBtnType: '',
  leftBtnTextColor: '#000000',
  rightBtnTextColor: '#108EE9',
  rightBtnTitle: '',
  rightBtnValue: '',
};
